/**
 * 催尾款
 *
 * @author Shann <851188611@qq.com>
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {Card, Form, DatePicker, Input, Select,Empty,Pagination,Spin,Button} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import "./RetroactivePayment.less";
import List from "./components/List"

const {RangePicker} = DatePicker;
const {Option} = Select;

class RetroactivePayment extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            extra:{},
            list:[],
            pageSize: 10,
            pageIndex: 1,
            total: 0,
        }
        this.model = {};
        this.filterForm = React.createRef();
    }

    /**
     * 获取数据
     **/
    getData(pageIndex, pageSize) {
        this.setState(
            {
                loading: true,
            },
            () => {
                let postData = {
                    pagingQuery: {
                        pageIndex: pageIndex || this.state.pageIndex,
                        pageSize: pageSize || this.state.pageSize,
                    },
                };
                postData = Object.assign(postData,this.model);
                if(postData.registerTime&&postData.registerTime.length>0){
                    if(postData.registerTime[0]){
                        postData.deliveryBeginTime = this.model.registerTime[0].valueOf()
                    }
                    if(postData.registerTime[1]){
                        postData.deliveryEndTime = this.model.registerTime[1].valueOf()
                    }
                    delete postData.registerTime;
                }

                if(postData.searchStatus){
                    postData.searchStatus = Number(postData.searchStatus);
                }

                $.ajax({
                    url: "/service/mg/balance-payment/list",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify(postData),
                    success: (res) => {
                        let data = {
                            loading: false,
                        };
                        if (res.success && res.valid) {
                            data = Object.assign(data, {
                                extra:res.extra||{},
                                list: res.models || [],
                            });
                        }
                        //分页
                        if (res.paging) {
                            data = Object.assign(data, {
                                pageIndex: res.paging.pageNum,
                                pageSize: res.paging.pageSize,
                                total: res.paging.total,
                            });
                        }
                        this.setState(data);
                    },
                    error: () => {
                        let data = {
                            loading: false,
                        };
                        this.setState(data);
                    },
                });
            }
        );
    }

    /**
     * 列表数据（更新）
     */
    handleChange = () => {
        this.getData();
    }

    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    onChangePage = (page, pageSize) => {
        $(document).scrollTop(0);
        this.getData(page, pageSize);
    };


    /**
     * 搜索
     **/
    onSearch(){
        this.model = this.filterForm.current.getFieldsValue();
        this.getData(1);
    }

    componentDidMount() {
        this.getData();
    }

    render(){
        let state = this.state;
        let { list, loading,extra} = this.state;
        return (
            <div className="RetroactivePayment" style={{minWidth:'1200px'}}>
                <CommonBreadcrumb
                    list={[{ name:Lang({id: 'CuiWeiKuan', default: '催尾款'}) }]}
                ></CommonBreadcrumb>
                <Spin spinning={loading}>
                    <Card title={<b>{Lang({id: "CuiWeiKuan", default: "催尾款"})}</b>}>
                        <Form ref={this.filterForm} className="input-form mb_16" layout="inline">
                            <Form.Item>
                                <Input.Group compact={true}>
                                    <Form.Item name="searchStatus" initialValue="0">
                                        <Select>
                                            <Option value="0"><Lang id="ZhuanGuanShiJian">转关时间</Lang></Option>
                                            <Option value="1"><Lang id="DaoGangShiJian">到港时间</Lang></Option>
                                            <Option value="2"><Lang id="RuKuShiJian">入库时间</Lang></Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name="registerTime">
                                        <RangePicker showTime placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                                    </Form.Item>
                                </Input.Group>
                            </Form.Item>
                            <Form.Item label={Lang({id: "DingDanBianHao", default: "订单编号"})} name="orderNumber">
                                <Input maxLength={100} style={{width: "204"}} placeholder={__getServerLanguage("QingShuRu")}/>
                            </Form.Item>
                            <Form.Item>
                                <Input.Group compact={true}>
                                    <Form.Item name="consignee" initialValue="1">
                                        <Select>
                                            <Option value="1"><Lang id="KeHuBianHao">客户编号</Lang></Option>
                                            <Option value="2"><Lang id="ShouHuoRenXingMing">收货人姓名</Lang></Option>
                                            <Option value="3"><Lang id="ShouHuoRenShouJi">收货人手机</Lang></Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name="searchParamOne">
                                        <Input style={{width: "204"}}/>
                                    </Form.Item>
                                </Input.Group>
                            </Form.Item>
                            <Form.Item>
                                <Button type="text" onClick={this.onSearch.bind(this)}><Lang id="SouSuo">搜索</Lang></Button>
                            </Form.Item>
                        </Form>
                        <div className="content-wrap">
                            <List extra={extra} list={list} onChange={this.handleChange}></List>
                        </div>
                        {/*列表为空*/}
                        {!loading && list.length < 1 ? (
                            <Empty
                                description={__getServerLanguage(
                                    "WeiZhaoDaoFuHeTiaoJianDeDingDan"
                                )}
                            />
                        ) : null}

                        {/*分页*/}
                        <div
                            className="margin-top-20"
                            style={{ display: list.length > 0 ? "block" : "none" }}
                        >
                            <Pagination
                                showTotal={total => (
                                    `Total ${state.total||0} items`
                                )}
                                showQuickJumper
                                current={state.pageIndex || 1}
                                defaultPageSize={state.pageSize || 50}
                                defaultCurrent={state.pageIndex || 1}
                                total={state.total || 0}
                                onChange={this.onChangePage.bind(this)}
                            />
                        </div>
                    </Card>
                </Spin>
            </div>
        )
    }
}

RetroactivePayment.defaultProps = {
}

export default RetroactivePayment;
